import React from 'react';
import PropTypes from 'prop-types';
import BlogView from 'epic-react-blog/app/scripts/views/BlogView';

export default class NewsWrapper extends React.Component {
    static propTypes = {
        params: PropTypes.object,
        router: PropTypes.object
    };

    render() {
        return (
            <div className="blog-wrapper">
                <BlogView {...this.props} enableForums={false} />
            </div>
        );
    }
}
